// address auto complete
document.addEventListener("turbo:load", () => {
  const container = document.getElementById("loc_search_fields");
  if (!container)
    return;

  console.log("Load: addresses/google_places.js")

  function initPlaces() {
    const input = document.getElementById("loc_search");
    if (!input || !window.google || !google.maps.places) return;

    const addr1 = document.getElementById("address1_real");
    const addr2 = document.getElementById("address2_real");
    const city  = document.getElementById("address_city_real");
    const state = document.getElementById("address_state_real");
    const zip   = document.getElementById("address_zip_real");
    const country = document.getElementById("address_country_real");

    const ac = new google.maps.places.Autocomplete(input, {
      types: ["address"],
      fields: ["address_components", "formatted_address"]
    });

    ac.addListener("place_changed", () => {
      const place = ac.getPlace();
      if (!place.address_components) return;

      [addr1, addr2, city, state, zip, country].forEach(f => f && (f.value = ""));

      let streetNumber = "";
      let route = "";
      let subpremise = "";

      place.address_components.forEach(c => {
        if (c.types.includes("street_number")) streetNumber = c.long_name;
        if (c.types.includes("route")) route = c.long_name;
        if (c.types.includes("locality")) city.value = c.long_name;
        if (c.types.includes("administrative_area_level_1")) state.value = c.short_name;
        if (c.types.includes("postal_code")) zip.value = c.long_name;
        if (c.types.includes("subpremise")) subpremise = c.long_name;
        if (c.types.includes("country") && country) country.value = c.long_name;
      });

      addr1.value = [streetNumber, route].filter(Boolean).join(" ");
      addr2.value = subpremise;
    });
  }

  // Run immediately if Google API is loaded
  if (window.google && google.maps && google.maps.places) {
    initPlaces();
  } else {
    // Fallback for async Google script loading
    window.initPlaces = initPlaces;
  }
});